import { createVision as _createVision } from '@griply/services';
import { collection, doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { NewVision, Vision } from 'shared/types/vision';

import { getAuthentication, getDatabase } from './helpers';

export const createVision = async (vision: NewVision): Promise<Vision> => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  return _createVision({
    vision,
    userId: user.uid,
    collection,
    doc,
    setDoc,
    db: getDatabase(),
    serverTimestamp,
  });
};
